import React, { forwardRef, useEffect } from 'react';
import { Link } from 'gatsby';
import { pathJoin } from 'utils';
import { useLocation } from '@reach/router';
import styled from 'styled-components';

const Breadcrumbs = forwardRef((props, ref) => {
  const { pathname } = useLocation();

  const home = ['/'];

  let currentPath = home.concat(pathname.split('/').filter((name) => name !== ''));

  // We pass in a hardcoded 'breadcrumb' prop on the top-level collection pages otherwise
  // the prop updates before the 400ms page transition is finished when you navigate between
  // top-level pages. Hardcoding it prevents this UI weirdness.
  const { removeProductNameFromPath, breadcrumb } = props;

  if (removeProductNameFromPath) {
    currentPath = currentPath.slice(0, -1);
  }

  let linkPath = '';

  const lastPage = currentPath.length > 0 ? currentPath.length - 1 : 0;

  const formatString = (string) =>
    string
      .split('-')
      .map((_string) => _string.slice(0, 1).toUpperCase() + _string.slice(1))
      .join(' ')
      .replace('And', '&');

  return (
    <Container ref={ref} className={props.className}>
      {currentPath.map((page, index) => {
        linkPath = pathJoin([linkPath, page]);

        // eslint-disable-next-line no-param-reassign
        page = page === '/' ? 'home' : page;

        return index !== lastPage || removeProductNameFromPath ? (
          <li key={index} style={{ display: 'flex' }}>
            <History to={linkPath}>{formatString(page)}</History>
            {(index !== lastPage || removeProductNameFromPath) && <Break>&gt;</Break>}
          </li>
        ) : (
          <li key={index}>{breadcrumb || formatString(page)}</li>
        );
      })}
    </Container>
  );
});

const Container = styled.ul`
  display: flex;
  font-family: 'Open Sans', 'Segoe UI', Tahoma, sans-serif;
  font-size: 1rem;
  font-weight: 700;
  list-style-type: none;
  text-transform: capitalize;

  > *,
  a:link,
  a:visited {
    color: var(--connolly-red);
  }
`;

const Break = styled.div`
  padding-left: 0.625rem;
  padding-right: 0.625rem;
`;

const History = styled(Link)`
  box-shadow: none;
`;

export default Breadcrumbs;
